import React from 'react';
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {Hero} from "../../components/hero/Hero";
import {connect} from "react-redux";
import {NewsListCard} from "../../components/item/NewsListCard";
import {ListLayout} from "../../components/layout/ListLayout";
import {PaginationItemGroup} from "../../components/item-group/PaginationItemGroup";
import { isoDateFormat } from "../../util/DateFormat";
import {Helmet} from "react-helmet";

class NewsListViewContainer extends React.Component {

  constructor(props) {
    super(props);

    this.loadNews = this.loadNews.bind(this);
    this.newPage = page => this.props.wpapi
      .news()
      .perPage(10)
      .page(page)
      .then( response => {
        const categories = this.props.post_categories;

        const news = response.map( news => {
          news.categories = news.categories
            .map( id => categories.find( category => category.id === id ));
          return news;
        });

        news._paging = response._paging;

        return Promise.resolve(news);
      });

    this.state = {
      title: "News",
      subtitle: " ",
      news: []
    };
  }

  componentDidMount() {
    this.setState({ news: this.loadNews(this.props.newsList)});
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.newsList){
      this.setState({ news: this.loadNews(nextProps.newsList)});
    }
  }

  loadNews(newsList) {
    if(newsList.parsed)
      return newsList;

    const list = newsList
      .map( news_story => {
        let news_mapped = null;

        try {
          news_mapped = {
            title: news_story.title && news_story.title.rendered,
            content: news_story.excerpt && news_story.excerpt.rendered,
            slug: news_story.slug,
            type: Array.isArray(news_story.categories) && news_story.categories[0].name,
            date: isoDateFormat(news_story.date),
            image: (() => {
              let image = null;

              try {
                image = news_story._embedded["wp:featuredmedia"][0].source_url;
              } catch (e) {
              }

              return image;
            })()
          };
        } catch(e){}

        return news_mapped;
      })
      .filter( n => n );

    list.parsed = true;

    return list;
  }

  render(){
    return (
      <div>
        <Helmet>
          <title>News | Obelux Aviation Lights</title>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>
        <header>
          <Hero title={ this.state.title }
                subtitle={ this.state.subtitle }
                align="center"
                className="small-hero"/>
        </header>
        <PaginationItemGroup
                className="news-list"
                layout={ ListLayout }
                layoutAttributes={{ noGutters: true, single_row: true }}
                item={ NewsListCard }
                data={this.state.news}
                adapter={this.loadNews}
                paging={this.props.newsList && this.props.newsList._paging}
                apiCallFunc={this.newPage}/>
        <ContactUsHiddenFormSection/>
      </div>
    );
  }
}

export const NewsListView = connect(
  state => ({
    newsList: ( state.resolve.data && state.resolve.data.news_list ) || [],
    wpapi: state.WPAPI.instance,
    post_categories: state.resolve.data.post_categories
  })
)(NewsListViewContainer);



// WEBPACK FOOTER //
// ./src/views/news/NewsList.js